
    <div [class.client-view]="clientView" [class.client-message]="fromClient" class="ezs-message">
      <span class="ezs-message-wrapper elevation-2">{{message.text}}</span>
      <span *ngIf="!fromClient && !clientView" class="user-profile-picture">
        <img [src]="userPhotoURL"/>
      </span>
      <span class="ezs-message-timestamp">{{message.createdAt | moment:'ddd MMM D, YYYY h:mm a'}}</span>
    </div>
  